var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationMarkerMeest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M20 0C11.6641 0 5 6.664 5 15c0 2.8828.8594 5.1094 2.3516 7.3672l11.0703 16.7969c.3359.5078.914.8359 1.5781.8359s1.25-.3359 1.5781-.8359l11.0703-16.7969C34.1406 20.1094 35 17.8828 35 15c0-8.336-6.6641-15-15-15m0 23.3281c-4.6016 0-8.3359-3.7343-8.3359-8.3437S15.3984 6.6406 20 6.6406s8.3359 3.7344 8.3359 8.3438S24.6016 23.3281 20 23.3281"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15,
    r: 12,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    fillRule: "evenodd",
    d: "m28.7677 13.9504-.2208-.4018h-.6597v.8266h.6471zM13.392 17.4418l.9648-3.8925.2583 3.9747h1.083l-.3302-5.0694h-1.6902l-.8287 3.407-.8287-3.407h-1.6901L10 17.524h1.083l.2586-3.9747.9644 3.8925zm12.6216-3.0663h.5706v1.6414c0 .8625.2156 1.5059 1.1626 1.5059.3424 0 .6249-.0865.7845-.1511l.0001-.922c-.5657.1066-.8411.1426-.8411-.6168v-3.377l-1.1061.0004v1.0926h-.4846zm-1.3885.2238c0-.4968.918-.3368 1.1963-.2239l.0857-.8263c-.9306-.2901-2.3734-.0737-2.3714 1.1592-.019 1.2161 1.7592 1.0503 1.7592 1.629 0 .6107-1.3935.2979-1.6963.1124l-.1584.827c1.0353.4602 3.0009.3585 2.9484-1.0244-.0179-1.3412-1.7635-1.1037-1.7635-1.653m-2.3667.43c0-1.0788-1.4455-1.0933-1.4349 0zm-1.4428.8344c.0759.9554 1.5534.7897 2.193.5859l.1589.8269c-1.4954.5761-3.4909.2006-3.4909-1.7578 0-2.6107 3.7056-2.894 3.7056-.1357 0 .2084-.0235.393-.0394.4807z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60033",
    fillRule: "evenodd",
    d: "M29.1432 12.4561h-.82l.8213 1.4946-.8213 1.4946h.82l.8308-1.4946zm-10.7965 2.5738c0-1.0788-1.4455-1.0933-1.4349 0zm-1.4441.8339c.076.9555 1.5535.7897 2.1931.5859l.1588.8269c-1.4953.5762-3.4908.2006-3.4908-1.7578 0-2.6107 3.7055-2.8939 3.7055-.1356 0 .2083-.0235.3929-.0393.4806z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationMarkerMeest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-marker-meest.c4b16d684bca1d48e302be67419e0a21.svg";